import React from 'react';
import SheduledBasicInfoComponent from './sheduled-basic-info.component';
import TasksComponent from './sheduled-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';


export const SheduledComponent = ({ selectedSheduledTasksValues,sheduledType, accountTypesListLoading, accountListLoading, accountsList, accountTypesList, configurationItem, ScheduledTaskType, PolicyOwnerType, platForms, onFormItemChange, selectedSheduledTasks, columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit, communities, Programs }: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <SheduledBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedSheduledTasks={selectedSheduledTasks}
                    PolicyOwnerType={PolicyOwnerType}
                    accountTypesList={accountTypesList}
                    accountTypesListLoading={accountTypesListLoading}
                    accountsList={accountsList}
                    accountListLoading={accountListLoading}


                />
            ),
            isVisible: true,
        },
        // {
        //     id: 2,
        //     title: 'Media',
        //     component:
        //         <UploadMedia
        //             handleInnerFormChange={handleInnerMediaFormChange}
        //             mediaFilesList={selectedEvents?.MediaMappings?.MediaFiles}
        //             ownerTypeId={1007}
        //             ownerId={id}
        //             folderName={'event'}
        //         />,
        //     isVisible: true,
        // },
        {
            id: 2,
            title: 'Tasks',
            component:
                <TasksComponent
                    handleDelete={handleDelete}
                    additionButtons={additionButtons}
                    handleEdit={handleEdit}
                    columnDefs={columnDefs}
                    platForms={platForms}
                    sheduledType={sheduledType}
                    ScheduledTaskType={ScheduledTaskType}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedSheduledTasksValues={selectedSheduledTasksValues}
                    configurationItem={configurationItem}
                />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default SheduledComponent;
